import React from "react"

import Title from "../../design-system/title"
import { BlogPostPreview } from "../../page-components/blog/types"
import { classNames } from "../../utils/class-names"
import BlogMetadata from "../blog-metadata"
import BlogTagCollection from "../blog-tag-collection"
import OptimizedImage from "../optimized-image"
import * as styles from "./index.module.scss"

// Blog posts created before this date use an old image style, that looks
// broken in smaller screens, if we apply the same style as the newer ones.
const IMAGE_STYLE_UPDATE_DATE = new Date("2023-06-06")

const ARTICLE_HEADER_ID = "article-header"

export const getArticleHeaderHeight = () => {
  const articleHeader = document.getElementById(ARTICLE_HEADER_ID)
  if (articleHeader) {
    return articleHeader.getBoundingClientRect().height
  }
  return 0
}

export type ArticleHeaderProps = Omit<
  BlogPostPreview,
  "slug" | "meta" | "datoUpdatedAt"
> & {
  updatedAt: string
  createdAt: string
  author: string
}

function ArticleHeader({
  title,
  author,
  coverImage,
  tags,
  minutesOfReading,
  updatedAt,
  createdAt,
}: ArticleHeaderProps) {
  return (
    <div id={ARTICLE_HEADER_ID}>
      <Title variant="2" as="h1" className={styles.title}>
        {title}
      </Title>
      <BlogMetadata
        author={author}
        minutesOfReading={minutesOfReading}
        updatedAt={updatedAt}
        className={styles.metadata}
      />
      <div className={styles.tagsContainer}>
        <BlogTagCollection tags={tags} withIcon />
      </div>
      <OptimizedImage
        className={classNames(
          styles.postImage,
          new Date(createdAt) < IMAGE_STYLE_UPDATE_DATE &&
            styles.blueBackgroundImage,
        )}
        src={coverImage.url}
        alt={coverImage.alt}
        preset="editorial"
      />
    </div>
  )
}

export default ArticleHeader
